import { min, max, format, isAfter, parse, isEqual } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { currentDate } from "@/utils/current-date";

/**
 *
 * @param {string|null} date
 * @returns {string|null}
 */
const forceToUtc = date => {
  if (!date || typeof date !== "string") {
    return date;
  }
  // API format is 2023-09-30T08:00:00+00:00
  // So we need to be tricky and remove +00:00 from date string
  if (date.includes("+")) {
    // get first half of date string
    // then force the time from Chicago to UTC to get correct time
    // to work with later.
    return zonedTimeToUtc(date.split("+")[0], "America/Chicago").toISOString();
  }
  // format: 2024-07-11 17:00
  return zonedTimeToUtc(`${date}:00`, "America/Chicago").toISOString();
};

const calcaluateDates = pkg => {
  let minDate = null;
  let maxDate = null;
  const currDate = currentDate();
  const dates = pkg.Dates?.map(d =>
    // force to UTC after parsing
    // format is always 2024-07-11 17:00
    zonedTimeToUtc(`${d.Date}:00`, "America/Chicago")
  );

  try {
    minDate = min(dates);
    maxDate = max(dates);
  } catch (err) {
    console.log("DATE ERROR", err);
  }

  const onSale = forceToUtc(pkg.OnSale);
  const offSale = forceToUtc(pkg.OffSale);

  const onSaleDate = new Date(onSale);
  let offSaleDate = null;
  if (offSale) {
    offSaleDate = new Date(offSale);
  }

  const isOffSale =
    isAfter(currDate, maxDate) ||
    (offSaleDate &&
      (isAfter(currDate, offSaleDate) || isEqual(currDate, offSaleDate)));

  let isOnSale = isAfter(currDate, onSaleDate) || isEqual(currDate, onSaleDate);
  if (isOnSale && offSaleDate) {
    isOnSale = !isAfter(currDate, offSaleDate);
  }
  if (isOnSale && maxDate) {
    isOnSale = !isAfter(currDate, maxDate);
  }
  return {
    currDate,
    minDate,
    maxDate,
    onSale,
    isOnSale,
    isOffSale
  };
};

export const formatSinglePackage = pkg => {
  const {
    currDate,
    minDate,
    maxDate,
    onSale,
    isOnSale,
    isOffSale
  } = calcaluateDates(pkg);
  return {
    ...pkg,

    firstDate: format(minDate, "EEE MMM dd @ hh:mma"),
    lastDate: format(maxDate, "EEE MMM dd @ hh:mma"),

    onSaleFormatted: onSale ? format(new Date(onSale), "MM/dd/yyyy") : null,
    isOnSale,
    isOffSale,
    eventOver: isAfter(currDate, maxDate) || isEqual(currDate, maxDate),
    Tickets: pkg.Tickets.map(t => {
      return {
        ...t,
        TitleLine:
          `${t.EventTitle} / ` +
          format(
            parse(t.Date, "yyyy-MM-dd HH:mm", currDate),
            "EEE MMM d @ h:mma"
          )
      };
    })
  };
};

export const formatPackagesInList = packages => {
  return packages.map(pkg => {
    const { minDate, maxDate, isOnSale, isOffSale } = calcaluateDates(pkg);
    return {
      ...pkg,
      isOnSale,
      isOffSale,
      minDate: format(minDate, "EEE MMM d @ h:mma"),
      maxDate: format(maxDate, "EEE MMM d @ h:mma"),
      Price: parseInt(pkg.Price),
      isEvent: false
    };
  });
};
